export default "__VITE_ASSET__sfSa5mpW__"